import { Component, Pipe, PipeTransform } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
import { Router } from '@angular/router';
import { getImageSrc } from '../core/images';

/**
 * Get the image source for the given image name pipe.
 */
@Pipe({
  standalone: true,
  name: 'getImageSrc',
})
export class GetImageSrcPipe implements PipeTransform {
  transform(imageName: string): string {
    return getImageSrc(imageName);
  }
}

@Component({
  selector: 'app-trial-ended-banner',
  imports: [CommonModule, MatCardModule, MatButtonModule, TranslateModule, GetImageSrcPipe],
  templateUrl: './trial-ended-banner.component.html',
  styleUrl: './trial-ended-banner.component.scss',
})
export class TrialEndedBannerComponent {
  constructor(
    private readonly productAnalyticsService: ProductAnalyticsService,
    private readonly router: Router,
  ) {}

  redirectToUpgradePage(): void {
    this.productAnalyticsService.trackEvent('upgrade-click', 'trial-ended-banner', 'click');
    this.router.navigateByUrl('/upgrade');
  }
}
